<form [formGroup]="form">
  <div class="row">
    <div class="divRadio col-6">
      <mat-form-field appearance="outline" class="dateInputValidacion">
        <mat-label>Fecha</mat-label>
        <input
          matInput
          formControlName="fecha_realizacion"
          [matDatepicker]="picker2"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="picker2"
        ></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-6">
      <mat-form-field style="width: 100%">
        <mat-label>Correo</mat-label>
        <input
          type="text"
          formControlName="email_usado"
          matInput
          placeholder="Ingrese su correo"
        />
        <mat-error *ngIf="form.get('email_usado').hasError('required')"
          >El correo es <strong>requerido</strong></mat-error
        >
        <mat-error *ngIf="form.get('email_usado').hasError('email')"
          >El correo es <strong>invalido</strong></mat-error
        >
      </mat-form-field>
    </div>
    <div class="col-12 divCheck">
      <p class="textoRadio">Solicitante informado por correo</p>
      <mat-radio-group
        class="formRadio"
        formControlName="informado_correo"
        aria-label="Select an option"
      >
        <mat-radio-button value="Si">Si</mat-radio-button>
        <mat-radio-button style="margin-left: 10px" value="No"
          >No</mat-radio-button
        >
      </mat-radio-group>
    </div>
  </div>
</form>
